import React, { useState } from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
// import { useHistory } from 'react-router-dom';  // Assuming you're using react-router for navigation

// Assuming the login state is managed in local state (it can be from context, redux, etc.)
// Set this to `true` when user is logged in (you can replace this with your actual state logic)

const Container = styled.div`
    display: flex;
    flex-direction: column;
    margin: 30px 100px;
    width:100%
    text-align: left;

  @media (max-width: 768px)  {
   text-align:center;
   justify-content:center;
   align-items:center;
   margin:0;
  }

   @media (max-width: 1020px) and (min-width: 768px) {
     text-align:center;
   justify-content:center;
   align-items:center;
   margin:0;
  }
`;

const Title = styled.div`
   font-size: 40px;
   display: flex;
   color: #385963;
   font-weight: 600;
   margin-bottom: 10px;
  //  justify-content: left;
  @media (max-width: 768px) {
    font-size:25px;
  }
`;

const Description = styled.div`
   font-size: 20px;
   margin-bottom: 50px;
   color: #91abb3;
   display: flex;
  //  justify-content: left;
  @media (max-width: 768px) {
    font-size:12px;
    width:100%;
  }
`;

const FlexBox = styled.div`
    display: flex;
    gap: 100px;
    align-items:center;
    justify-content:center;

  @media (max-width: 768px) {
  flex-direction:column;
   text-align:center;
   justify-content:center;
   align-items:center;
  //  width:60vw;
    gap:0px;
  }
`;

const FormSection = styled.div`
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    h3{
    margin-bottom: 20px;
    color: #385963;
    }
`;


const TestimonialSection = styled.div`
    display: flex;
    flex-direction: column;
    margin-bottom: 50px;
    max-height: 500px; /* Default max height */
    overflow-y: auto; /* Add scroll when the content exceeds max height */
    padding-right: 15px; /* Create space for the scrollbar */
    padding-left: 10px; /* Optional: Adds some space on the left for design consistency */
    
    /* Media queries for responsiveness */
    @media (max-width: 1200px) {
        max-height: 400px; /* Smaller height for medium screens */
    }

    @media (max-width: 768px) {
        width:80vw;
        height:90vh;
    }

    // @media (max-width: 480px) {
    //     max-height: 250px; /* Even smaller height for very small screens */
    // }

    /* Custom scrollbar styling */
    ::-webkit-scrollbar {
        width: 12px; /* Adjust scrollbar width */
        margin-left: 10px; /* Add space on the left of the scrollbar */
    }

    ::-webkit-scrollbar-thumb {
        background-color: #91abb3; /* Change color of the scrollbar thumb */
        border-radius: 10px; /* Make the scrollbar thumb rounded */
    }

    ::-webkit-scrollbar-track {
        background: #f5f5f5; /* Change the background color of the track */
        border-radius: 10px; /* Rounded track */
    }
`;

const TestimonialCard = styled.div`
    background-color: #f5f5f5;
    border-radius: 10px;
    padding: 20px;
    margin-bottom: 30px;
    font-size: 18px;
    color: #3b3b3b;
    position: relative;
    max-width: 480px; /* Set a max-width for the card */
    word-wrap: break-word; /* Ensure long text wraps properly */

    &:before {
        content: '“';
        font-size: 60px;
        color: #91abb3;
        position: absolute;
        top: -10px;
        left: -10px;
    }

    &:after {
        content: '”';
        font-size: 60px;
        color: #91abb3;
        position: absolute;
        bottom: -10px;
        right: -10px;
    }
`;

const FormTextArea = styled.textarea`
    padding: 10px;
    font-size: 16px;
    margin-bottom: 20px;
    width: 100%;
    max-width: 500px;
    height: 150px;
    border: 1px solid #ddd;
    border-radius: 5px;
`;

const Button = styled.button`
  background-color: white;
  color: #385963;
  font-weight: 400;
  border: #385963 solid 2px;
  height: 20px;
  padding: 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-decoration: none;
  margin-top: 10px;

  svg {
    margin-left: 10px;
  }

  &:hover {
    color: white;
    transition: 0.4s;
    cursor: pointer;
    background-color: #385963;
  }
`;

// New Sign-In message & button styling
const SignInMessage = styled.div`
  font-size: 18px;
  color: #91abb3;
  text-align: center;
  margin-top: 30px;
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
`;

const SignInButton = styled(Button)`
  max-width: 200px;  // Adjust the max-width as needed
`;

const Testemonies = () => {
   const { i18n } = useTranslation();
   const signedIn = sessionStorage.getItem("loggedIn");
   const navigate = useNavigate();

  const [testimonials, setTestimonials] = useState([
    { id: 1, text: 'Great service, I had a wonderful experience!' },
    { id: 2, text: 'Very helpful team and great atmosphere!amazing!!!!!!!!!!amazing!!!!!!!!!!amazing!!!!!!!!!!amazing!!!!!!!!!!' },
    { id: 3, text: 'Would definitely recommend to others! Pieria is great to visit.' },
    { id: 4, text: 'This is amazing!!!!!!!!!!Would definitely recommend to others!' },
    { id: 5, text: 'Would definitely recommend to others!Would definitely recommend to others!' },
    { id: 6, text: 'Something magical about this place.Would definitely recommend to others!' },
    { id: 7, text: 'Would definitely recommend to others!' },
    { id: 8, text: 'Would definitely recommend to others!' },
    { id: 9, text: 'Would definitely recommend to others!' },
    { id: 10, text: 'Would definitely recommend to others!' },
    { id: 11, text: 'Would definitely recommend to others!' },
  ]);

  const [newTestimonial, setNewTestimonial] = useState('');
  
  // const history = useHistory();

  const handleSubmit = (e) => {
    e.preventDefault();
    if (newTestimonial) {
      setTestimonials([...testimonials, { id: testimonials.length + 1, text: newTestimonial }]);
      setNewTestimonial('');
    }
  };

  // const handleSignInRedirect = () => {
  //   history.push('/signin');  // This will navigate to the sign-in page
  // };

  return (
    <Container>
      <Title>{i18n.t('testimonies').toUpperCase()}</Title>
      <Description>{i18n.t('testimoniesDescription')}</Description>

      <FlexBox>
        {/* Display testimonials */}
        <div>
          <TestimonialSection>
            {testimonials.map((testimonial) => (
              <TestimonialCard key={testimonial.id}>
                {testimonial.text}
              </TestimonialCard>
            ))}
          </TestimonialSection>
        </div>

        {/* Conditional rendering based on login status */}
        {signedIn ? (
          <FormSection>
            <h3>{i18n.t('shareYourExperience')}</h3>
            <FormTextArea
              placeholder={i18n.t('yourTestimonial')}
              value={newTestimonial}
              onChange={(e) => setNewTestimonial(e.target.value)}
            />
            <Button onClick={handleSubmit}>{i18n.t('submit')}</Button>
          </FormSection>
        ) : (
          <SignInMessage>
            <p>{i18n.t('testimonySignInMessage')}</p>
            <SignInButton onClick={() => navigate('/register-signIn')}>{i18n.t('signIn')}</SignInButton>
          </SignInMessage>
        )}
      </FlexBox>
    </Container>
  );
};

export default Testemonies;
